import { KeyboardArrowLeft, KeyboardArrowRight } from '@mui/icons-material'
import { Button, MobileStepper, useTheme } from '@mui/material'
import { getPxAsRem } from 'shared/utils'

import type { FC } from 'react'

interface ProgressStepperProps {
    steps: number
    currentStep: number
    handleStep: (step: number) => void
    answers?: Record<any, any>[]
}

export const ProgressStepper: FC<ProgressStepperProps> = ({
    steps,
    currentStep,
    handleStep,
    answers,
}) => {
    const theme = useTheme()

    const handleNext = () => {
        if (currentStep >= steps - 1) return

        handleStep(currentStep + 1)
    }

    const handleBack = () => {
        if (currentStep <= 0) return

        handleStep(currentStep - 1)
    }

    return (
        <MobileStepper
            variant="text"
            steps={steps}
            // The `position` prop seems contradictory to the sticky styles
            // below, but this is really just opting out of MUI's default fixed
            // positioning for this component.
            position="static"
            sx={{
                bottom: 0,
                left: 0,
                padding: getPxAsRem(20),
                position: 'sticky',
            }}
            activeStep={currentStep}
            nextButton={
                <Button
                    size="small"
                    variant="text"
                    onClick={handleNext}
                    disabled={
                        currentStep === (answers?.length ?? 0) ||
                        currentStep === steps - 1
                    }
                >
                    Next
                    {theme.direction === 'rtl' ? (
                        <KeyboardArrowLeft />
                    ) : (
                        <KeyboardArrowRight />
                    )}
                </Button>
            }
            backButton={
                <Button
                    size="small"
                    onClick={handleBack}
                    variant="text"
                    disabled={currentStep === 0}
                >
                    {theme.direction === 'rtl' ? (
                        <KeyboardArrowRight />
                    ) : (
                        <KeyboardArrowLeft />
                    )}
                    Back
                </Button>
            }
        />
    )
}
